<template>
  <div id="userList" class="containerPage">
    <div class="search-area">
      <el-form ref="form" :model="searchForm" label-width="80px" inline>
        <el-form-item
          v-for="(item, index) in searchList"
          :key="index"
          :label="item.label"
        >
          <el-input
            v-if="item.type === 'input'"
            v-model="searchForm[item.key]"
          ></el-input>
          <el-select
            v-if="item.type === 'select'"
            v-model="searchForm[item.key]"
            placeholder="请选系统"
          >
            <el-option
              v-for="element in item.select"
              :key="element.id"
              :label="element.appSystemName"
              :value="element.appSystemCode"
            ></el-option>
          </el-select>
          <el-date-picker
            v-if="item.type === 'date-picker'"
            type="date"
            placeholder="选择日期"
            v-model="searchForm[item.key]"
            style="width: 100%"
          ></el-date-picker>
          <el-switch
            v-if="item.type === 'switch'"
            v-model="searchForm[item.key]"
          ></el-switch>
          <el-checkbox-group
            v-if="item.type === 'checkbox-group'"
            v-model="searchForm[item.key]"
          >
            <el-checkbox
              v-for="element in item.select"
              :key="element.label"
              :label="element.label"
              name="type"
            ></el-checkbox>
          </el-checkbox-group>
          <el-radio-group
            v-if="item.type === 'radio-group'"
            v-model="searchForm[item.key]"
          >
            <el-radio
              v-for="element in item.select"
              :key="element.label"
              :label="element.label"
            ></el-radio>
          </el-radio-group>
          <el-input
            v-if="item.type === 'textarea'"
            type="textarea"
            v-model="searchForm[item.key]"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="operation-area">
      <el-button type="primary" @click="add">新增</el-button>
      <el-button :disabled="selectedRows.length !== 1" @click="edit"
        >编辑</el-button
      >
      <el-button :disabled="selectedRows.length !== 1" @click="detail"
        >详情</el-button
      >
      <el-button
        :disabled="selectedRows.length === 0"
        @click="batchDeletePrompt"
        >批量删除</el-button
      >
      <!-- <el-button :disabled="selectedRows.length !== 1" @click="roleAssign"
        >角色分配</el-button
      > -->
      <el-button :disabled="selectedRows.length !== 1" @click="authorityAssign"
        >权限分配</el-button
      >
    </div>

    <div class="data-list">
      <el-table
        @row-click="clickRow"
        :data="dataList"
        border
        highlight-current-row
        ref="Table"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column
          label="序号"
          prop="id"
          align="center"
          fixed="left"
          width="80"
        >
          <template slot-scope="scope">
            {{ page * pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column
          v-for="(col, index) in cols"
          :key="index"
          :prop="col.prop"
          :label="col.label"
        >
          <template slot-scope="scope">
            <div v-if="!col.isArr">{{ scope.row[col.prop] }}</div>
            <div v-else>
              <span v-if="col.prop == 'hobby'">
                {{ getShowName(scope.row[col.prop]) }}
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        background
        :current-page="page + 1"
        :page-sizes="[2, 10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentPageChange"
      />
    </div>
    <AddDialog
      ref="addDialog"
      :visible.sync="addForm"
      @add-success="refreshList"
    />
    <EditDialog
      ref="editDialog"
      :visible.sync="editForm"
      :data="editData"
      @edit-success="refreshList"
    />
    <DetailsDialog
      ref="detailsDialog"
      :visible.sync="detailForm"
      :data="editData"
    />
    <!-- <roleAssign
      :visible.sync="roleAssignForm"
      :data="editData"
      @refreshList="refreshList"
      ref="roleAssignDialog"
    />
    -->
    <authorityAssign
      :visible.sync="authorityAssignForm"
      :data="itemInfo"
      ref="authAssignDialog"
    /> 
  </div>
</template>

<script>
import AddDialog from "./components/addDialog.vue";
import EditDialog from "./components/editDialog.vue";
import DetailsDialog from "./components/detailsDialog.vue";
// import roleAssign from "./components/roleAssign.vue";
import authorityAssign from "./components/authorityAssign.vue";
// import { getAllSystem } from "@/api/dataModel/appSystem";
// import { getPageList, getInfo, del } from "@/api/erModel/roleManagementEr";
import { getRolePageList,getRoleInfo,getAuthByMenu,delRole } from '@/api/systemData';


import store from "@/store";
export default {
  components: {
    AddDialog,
    EditDialog,
    DetailsDialog,
    // roleAssign,
    authorityAssign,
  },
  data() {
    return {
      searchForm: {},
      searchList: [
        { label: "角色名称", type: "input", key: "name" },
        { label: "角色编号", type: "input", key: "code" },
        // {
        //   label: "系统编码",
        //   type: "select",
        //   key: "code",
        //   select: [],
        // },
      ],
      cols: [
        { prop: "name", label: "角色名称", isArr: false },
        { prop: "code", label: "角色编码", isArr: false },
        { prop: "description", label: "角色描述", isArr: false },
        { prop: "companyId", label: "企业编号", isArr: false },
      ],
      dataList: [],
      hobbies: [
        { id: 1, type: "篮球1" },
        { id: 2, type: "篮球2" },
        { id: 3, type: "篮球3" },
        { id: 4, type: "篮球4" },
      ],
      total: 0,
      page: 0,
      pageSize: 10,
      selectedRows: [],
      editData: {},
      itemInfo: {},
      addForm: false, // 新增弹窗
      editForm: false, // 编辑弹窗
      detailForm: false, // 详情弹窗
      roleAssignForm: false, // 角色分配
      authorityAssignForm: false, // 权限分配
      allAppSystem: [],
    };
  },
  created() {
    this.getAllAppSystem();
    this.refreshSearchCondition();
    // setTimeout(() => {
    //   this.refreshList();
    // }, 100);
    this.refreshList();
  },
  methods: {
    // 全量应用
    async getAllAppSystem() {
      // let res = await getAllSystem();
      // this.allAppSystem = res.data;
      // this.searchList.forEach((item) => {
      //   if (item.key == "role_appSystemCode") {
      //     item.select = res.data;
      //   }
      // });
      // console.log("this.allAppSystem", this.allAppSystem);
    },

    // 系统地图
    goSystemMap() {},
    // 角色分配
    roleAssign() {
      console.log("this.selectedRows[0]",this.selectedRows[0]);
      this.roleAssignForm = true;
      this.getDataInfo(this.selectedRows[0].id);
      this.$refs.roleAssignDialog.getAllOrg();
    },
    // 权限分配
    authorityAssign() {
      // console.log("this.selectedRows[0]",this.selectedRows[0].id);
      // return;
      this.authorityAssignForm = true;
      // this.$refs.authAssignDialog.getAuthority();
      this.$refs.authAssignDialog.getAuthRoleMenu(
        // this.selectedRows[0].role_appSystemCode,
        this.selectedRows[0].id
      );
      this.itemInfo = this.selectedRows[0];
    },
    add() {
      this.addForm = true;
      // this.$refs.addDialog.getAppSys();
    },
    getShowName(id) {
      let flag = "";
      this.hobbies.forEach((item) => {
        if (item.id == id) {
          flag = item.type;
        }
      });
      return flag;
    },
    search() {
      this.page = 0;
      this.refreshList();
      // 调用服务端查询数据源列表
      // 更新dataList和total
    },
    reset() {
      this.searchForm = {};
      this.search();
    },
    edit() {
      this.editForm = true;
      // this.$refs.editDialog.getAppSys();
      this.getDataInfo(this.selectedRows[0].id);
    },
    detail() {
      this.detailForm = true;
      // this.$refs.detailsDialog.getAppSys();
      this.getDataInfo(this.selectedRows[0].id);
    },
    // 获取详情信息
    async getDataInfo(id) {
      let res = await getRoleInfo(id);
      console.log("res+++",res);
      if (res.code == 10000) {
        this.editData = res.data;
      }
    },
    batchDeletePrompt() {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.batchDelete();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    batchDelete() {
      // 批量删除选中的数据源
      const ids = this.selectedRows.map((item) => {
        return item.id;
      });
      let params = {
        ids:ids
      }
      delRole(params).then((res) => {
        if (res.code == 10000) {
          this.$message.success("删除成功");
          this.refreshList();
        }
      });
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.refreshList();
    },
    handleCurrentPageChange(page) {
      this.page = page - 1;
      this.refreshList();
    },
    getAppZhName(code) {
      let flag = "";
      this.allAppSystem.forEach((item) => {
        if (item.appSystemCode == code) {
          flag = item.appSystemName;
        }
      });
      return flag;
    },
    refreshList() {
      console.log(11111111111111111111111);
      const pageForm = {
        page: this.page,
        pageSize: this.pageSize,
      };
      console.log("pageForm",pageForm);
      console.log("this.searchForm",this.searchForm);
      let pageableForm = { ...pageForm, ...this.searchForm };

      getRolePageList(pageableForm).then((res) => {
        if (res.code == 10000) {
          console.log("res",res);
          this.dataList = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    refreshSearchCondition() {
      const form = {};
      this.searchList.forEach((item) => {
        if (item.type === "checkbox-group") {
          form[item.key] = [];
          console.log("form[item.key]", form[item.key]);
        } else if (item.type === "switch") {
          form[item.key] = false;
          console.log("form[item.key]1", form[item.key]);
        }
      });
      this.searchForm = form;
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    clickRow(row, column, event) {
      this.$refs.Table.toggleRowSelection(row);
    },
  },
};
</script>

<style scoped>
#userList {
  margin: 20px;
}

.operation-area {
  margin-bottom: 20px;
}

.data-list {
  background-color: #f5f7fa;
  padding: 10px;
}

.pagination {
  text-align: right;
  margin-top: 20px;
}
</style>
